"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidBlobNameError = exports.InvalidContainerError = void 0;
class InvalidContainerError extends Error {
    constructor(containerName) {
        super();
        this.name = 'InvalidContainerError';
        this.message = `Invalid container name: ${containerName}.`;
    }
}
exports.InvalidContainerError = InvalidContainerError;
class InvalidBlobNameError extends Error {
    constructor(blobName) {
        super();
        this.name = 'InvalidBlobNameError';
        this.message = `Invalid blob name: ${blobName}.`;
    }
}
exports.InvalidBlobNameError = InvalidBlobNameError;
//# sourceMappingURL=errors.js.map